let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jG8q4")).then(() => parcelRequire('4Cs4A'));